var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-wizard",
    {
      attrs: {
        color: "rgba(var(--vs-primary), 1)",
        errorColor: "rgba(var(--vs-danger), 1)",
        title: null,
        subtitle: null,
        nextButtonText: "Siguiente",
        backButtonText: "Anterior",
        finishButtonText: "Emitir"
      },
      on: { "on-complete": _vm.enviarDocumento }
    },
    [
      _c(
        "tab-content",
        {
          staticClass: "mb-5",
          attrs: {
            title: "Receptor",
            icon: "feather icon-user",
            "before-change": _vm.validarEncabezado
          }
        },
        [
          _c("form", { attrs: { "data-vv-scope": "formularioEncabezado" } }, [
            _c("div", { staticClass: "vx-row" }, [
              _c(
                "div",
                { staticClass: "vx-col md:w-1/2 w-full" },
                [
                  _c(
                    "vs-select",
                    {
                      staticClass: "w-full select-large",
                      attrs: { name: "tipoDocumento", label: "Tipo Documento" },
                      model: {
                        value: _vm.encabezado.tipoDocumento,
                        callback: function($$v) {
                          _vm.$set(_vm.encabezado, "tipoDocumento", $$v)
                        },
                        expression: "encabezado.tipoDocumento"
                      }
                    },
                    _vm._l(_vm.tiposDocumento, function(item, index) {
                      return _c("vs-select-item", {
                        key: index,
                        staticClass: "w-full",
                        attrs: { value: item.value, text: item.text }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "vx-col md:w-1/2 w-full pt-4" },
                [
                  _vm.encabezado.tipoDocumento == 39 ||
                  _vm.encabezado.tipoDocumento == 41
                    ? _c(
                        "vs-switch",
                        {
                          staticStyle: { width: "100px" },
                          attrs: { color: "success" },
                          model: {
                            value: _vm.encabezado.nominativa,
                            callback: function($$v) {
                              _vm.$set(_vm.encabezado, "nominativa", $$v)
                            },
                            expression: "encabezado.nominativa"
                          }
                        },
                        [
                          _c("span", { attrs: { slot: "on" }, slot: "on" }, [
                            _vm._v("Nominativa")
                          ]),
                          _c("span", { attrs: { slot: "off" }, slot: "off" }, [
                            _vm._v("Portador")
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.encabezado.tipoDocumento == 39 ||
                  _vm.encabezado.tipoDocumento == 41
                    ? _c(
                        "vs-switch",
                        {
                          staticStyle: { "margin-top": "2px", width: "100px" },
                          attrs: { color: "primary" },
                          model: {
                            value: _vm.encabezado.detalle,
                            callback: function($$v) {
                              _vm.$set(_vm.encabezado, "detalle", $$v)
                            },
                            expression: "encabezado.detalle"
                          }
                        },
                        [
                          _c("span", { attrs: { slot: "on" }, slot: "on" }, [
                            _vm._v("Detalle")
                          ]),
                          _c("span", { attrs: { slot: "off" }, slot: "off" }, [
                            _vm._v("Sin detalle")
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm.esNominativo
              ? _c("div", { staticClass: "vx-row" }, [
                  _c(
                    "div",
                    { staticClass: "vx-col md:w-1/2 w-full mt-5" },
                    [
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|validaRut",
                            expression: "'required|validaRut'"
                          }
                        ],
                        staticClass: "w-full",
                        attrs: {
                          label: "RUT Receptor (sin puntos, con guión)",
                          maxlength: "10",
                          name: "rutReceptor"
                        },
                        on: { change: _vm.encontrarReceptor },
                        model: {
                          value: _vm.encabezado.rutReceptor,
                          callback: function($$v) {
                            _vm.$set(_vm.encabezado, "rutReceptor", $$v)
                          },
                          expression: "encabezado.rutReceptor"
                        }
                      }),
                      _vm.getError("rutReceptor") == "required"
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "text-danger text-sm form-error-message"
                            },
                            [_vm._v("RUT es obligatorio")]
                          )
                        : _vm._e(),
                      _vm.getError("rutReceptor") == "rut"
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "text-danger text-sm form-error-message"
                            },
                            [_vm._v("Formato de RUT incorrecto")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "vx-col md:w-1/2 w-full mt-5" },
                    [
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-full",
                        attrs: {
                          label: "Razón Social",
                          maxlength: "100",
                          name: "razon_social"
                        },
                        model: {
                          value: _vm.encabezado.razonSocial,
                          callback: function($$v) {
                            _vm.$set(_vm.encabezado, "razonSocial", $$v)
                          },
                          expression: "encabezado.razonSocial"
                        }
                      }),
                      _vm.getError("razon_social")
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "text-danger text-sm form-error-message"
                            },
                            [_vm._v("Razón Social es obligatoria")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "vx-col md:w-1/2 w-full mt-5" },
                    [
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-full",
                        attrs: { label: "Giro", maxlength: "50", name: "giro" },
                        model: {
                          value: _vm.encabezado.giro,
                          callback: function($$v) {
                            _vm.$set(_vm.encabezado, "giro", $$v)
                          },
                          expression: "encabezado.giro"
                        }
                      }),
                      _vm.getError("giro")
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "text-danger text-sm form-error-message"
                            },
                            [_vm._v("Giro es obligatorio")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "vx-col md:w-1/2 w-full mt-5" },
                    [
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-full",
                        attrs: {
                          label: "Dirección",
                          maxlength: "150",
                          name: "direccion"
                        },
                        model: {
                          value: _vm.encabezado.direccion,
                          callback: function($$v) {
                            _vm.$set(_vm.encabezado, "direccion", $$v)
                          },
                          expression: "encabezado.direccion"
                        }
                      }),
                      _vm.getError("direccion")
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "text-danger text-sm form-error-message"
                            },
                            [_vm._v("Dirección es obligatoria")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "vx-col md:w-1/2 w-full mt-5" },
                    [
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-full",
                        attrs: {
                          label: "Comuna",
                          maxlength: "40",
                          name: "comuna"
                        },
                        model: {
                          value: _vm.encabezado.comuna,
                          callback: function($$v) {
                            _vm.$set(_vm.encabezado, "comuna", $$v)
                          },
                          expression: "encabezado.comuna"
                        }
                      }),
                      _vm.getError("comuna")
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "text-danger text-sm form-error-message"
                            },
                            [_vm._v("Comuna es obligatoria")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "vx-col md:w-1/2 w-full mt-5" },
                    [
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-full",
                        attrs: {
                          label: "Ciudad",
                          maxlength: "40",
                          name: "ciudad"
                        },
                        model: {
                          value: _vm.encabezado.ciudad,
                          callback: function($$v) {
                            _vm.$set(_vm.encabezado, "ciudad", $$v)
                          },
                          expression: "encabezado.ciudad"
                        }
                      }),
                      _vm.getError("ciudad")
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "text-danger text-sm form-error-message"
                            },
                            [_vm._v("Ciudad es obligatoria")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _c("div", { staticClass: "vx-row" }, [
              _c(
                "div",
                { staticClass: "vx-col md:w-1/2 w-full mt-5" },
                [
                  _c("vs-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email",
                        expression: "'required|email'"
                      }
                    ],
                    staticClass: "w-full",
                    attrs: {
                      type: "email",
                      label: "Email",
                      maxlength: "90",
                      name: "email"
                    },
                    model: {
                      value: _vm.encabezado.email,
                      callback: function($$v) {
                        _vm.$set(_vm.encabezado, "email", $$v)
                      },
                      expression: "encabezado.email"
                    }
                  }),
                  _vm.getError("email") == "required"
                    ? _c(
                        "span",
                        {
                          staticClass: "text-danger text-sm form-error-message"
                        },
                        [_vm._v("Correo electrónico es obligatorio")]
                      )
                    : _vm._e(),
                  _vm.getError("email") == "email"
                    ? _c(
                        "span",
                        {
                          staticClass: "text-danger text-sm form-error-message"
                        },
                        [_vm._v("Correo electrónico es incorrecto")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "vx-col md:w-1/2 w-full mt-5" },
                [
                  !_vm.tieneDetalle
                    ? _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|min:0",
                            expression: "'required|min:0'"
                          }
                        ],
                        staticClass: "w-full",
                        attrs: {
                          type: "number",
                          label: "Valor bruto",
                          name: "valor",
                          maxlength: "10",
                          min: 0
                        },
                        model: {
                          value: _vm.total,
                          callback: function($$v) {
                            _vm.total = $$v
                          },
                          expression: "total"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm.encabezado.detalle
        ? _c(
            "tab-content",
            {
              staticClass: "mb-5",
              attrs: {
                title: "Detalle",
                icon: "feather icon-list",
                "before-change": _vm.validarDetalle
              }
            },
            [
              _c(
                "vs-button",
                {
                  attrs: { size: "small", color: "primary", type: "filled" },
                  on: {
                    click: function($event) {
                      return _vm.agregarArticulo()
                    }
                  }
                },
                [_vm._v("Agregar artículos")]
              ),
              _c(
                "div",
                { staticClass: "prueba" },
                [
                  _c(
                    "vs-table",
                    {
                      attrs: {
                        stripe: "",
                        pagination: "",
                        "max-items": 5,
                        data: _vm.detalle
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var data = ref.data
                              return _vm._l(data, function(tr, indextr) {
                                return _c(
                                  "vs-tr",
                                  { key: indextr },
                                  [
                                    _c(
                                      "vs-td",
                                      {
                                        attrs: {
                                          data: data[indextr].descripcion
                                        }
                                      },
                                      [
                                        _vm.edicionDetalle != indextr
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  data[indextr].descripcion
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm.edicionDetalle == indextr
                                          ? _c("vs-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required|alpha",
                                                  expression: "'required|alpha'"
                                                }
                                              ],
                                              staticClass: "w-full",
                                              attrs: {
                                                name: "descripcion",
                                                maxlength: "100",
                                                required: ""
                                              },
                                              model: {
                                                value:
                                                  data[indextr].descripcion,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    data[indextr],
                                                    "descripcion",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "data[indextr].descripcion"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-td",
                                      {
                                        attrs: {
                                          data: data[indextr].unidadMedida
                                        }
                                      },
                                      [
                                        _vm.edicionDetalle != indextr
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  data[indextr].unidadMedida
                                                )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm.edicionDetalle == indextr
                                          ? _c("vs-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required|alpha",
                                                  expression: "'required|alpha'"
                                                }
                                              ],
                                              staticClass: "w-full",
                                              attrs: {
                                                name: "unidadMedida",
                                                maxlength: "20",
                                                required: ""
                                              },
                                              model: {
                                                value:
                                                  data[indextr].unidadMedida,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    data[indextr],
                                                    "unidadMedida",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "data[indextr].unidadMedida"
                                              }
                                            })
                                          : _vm._e(),
                                        _c("span", {
                                          staticClass: "text-danger"
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-td",
                                      {
                                        staticStyle: { "text-align": "center" },
                                        attrs: { data: data[indextr].cantidad }
                                      },
                                      [
                                        _vm.edicionDetalle != indextr
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(data[indextr].cantidad)
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm.edicionDetalle == indextr
                                          ? _c("vs-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required|min:1",
                                                  expression: "'required|min:1'"
                                                }
                                              ],
                                              staticClass: "w-full",
                                              attrs: {
                                                type: "number",
                                                name: "cantidad",
                                                maxlength: "5",
                                                required: "",
                                                min: 1
                                              },
                                              model: {
                                                value: data[indextr].cantidad,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    data[indextr],
                                                    "cantidad",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "data[indextr].cantidad"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-td",
                                      {
                                        staticStyle: { "text-align": "right" },
                                        attrs: { data: data[indextr].precio }
                                      },
                                      [
                                        _vm.edicionDetalle != indextr
                                          ? _c("span", [
                                              _vm._v(
                                                "$" +
                                                  _vm._s(
                                                    new Intl.NumberFormat()
                                                      .format(
                                                        data[indextr].precio
                                                      )
                                                      .replace(/,/g, ".")
                                                  )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm.edicionDetalle == indextr
                                          ? _c("vs-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required|min:0",
                                                  expression: "'required|min:0'"
                                                }
                                              ],
                                              staticClass: "w-full",
                                              attrs: {
                                                type: "number",
                                                name: "precio",
                                                maxlength: "10",
                                                required: "",
                                                min: 0
                                              },
                                              model: {
                                                value: data[indextr].precio,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    data[indextr],
                                                    "precio",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "data[indextr].precio"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "vs-td",
                                      {
                                        staticStyle: { "text-align": "right" },
                                        attrs: { data: data[indextr].precio }
                                      },
                                      [
                                        _vm._v(
                                          " $" +
                                            _vm._s(
                                              new Intl.NumberFormat()
                                                .format(
                                                  data[indextr].cantidad *
                                                    data[indextr].precio
                                                )
                                                .replace(/,/g, ".")
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "vs-td",
                                      {
                                        attrs: {
                                          data: data[indextr].descripcion
                                        }
                                      },
                                      [
                                        _vm.edicionDetalle != indextr
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "btn-group",
                                                attrs: { role: "group" }
                                              },
                                              [
                                                _c(
                                                  "vs-button",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      color: "success"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.editarDetalle(
                                                          indextr
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("vs-icon", {
                                                      attrs: { icon: "edit" }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "vs-button",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      color: "danger"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.eliminarDetalle(
                                                          tr,
                                                          indextr
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("vs-icon", {
                                                      attrs: { icon: "delete" }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.edicionDetalle == indextr
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "btn-group",
                                                attrs: { role: "group" }
                                              },
                                              [
                                                _c(
                                                  "vs-button",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.detalleAceptar(
                                                          tr,
                                                          indextr
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(" Guardar ")]
                                                ),
                                                _vm.esNuevo
                                                  ? _c(
                                                      "vs-button",
                                                      {
                                                        attrs: {
                                                          size: "small",
                                                          color: "dark"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.detalleCencelar(
                                                              indextr
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v(" Cancelar ")]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ],
                                  1
                                )
                              })
                            }
                          }
                        ],
                        null,
                        false,
                        3745134016
                      )
                    },
                    [
                      _c(
                        "template",
                        { slot: "thead" },
                        [
                          _c("vs-th", [_vm._v("Descripción")]),
                          _c("vs-th", [_vm._v("UM")]),
                          _c(
                            "vs-th",
                            { staticStyle: { "text-align": "center" } },
                            [_vm._v("Cantidad")]
                          ),
                          _c(
                            "vs-th",
                            { staticStyle: { "text-align": "right" } },
                            [_vm._v("Unitario")]
                          ),
                          _c(
                            "vs-th",
                            { staticStyle: { "text-align": "right" } },
                            [_vm._v("Total")]
                          ),
                          _c("vs-th", [_vm._v("Acción")])
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _c("br"),
              _c("h4", { attrs: { align: "right" } }, [
                _vm._v(
                  " Total: $ " +
                    _vm._s(
                      new Intl.NumberFormat()
                        .format(_vm.total)
                        .replace(/,/g, ".")
                    ) +
                    " "
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "tab-content",
        {
          staticClass: "mb-5",
          attrs: {
            title: "Confirmación",
            icon: "feather icon-download",
            "before-change": _vm.validarEmision
          }
        },
        [
          _c(
            "vs-row",
            { attrs: { "vs-justify": "center" } },
            [
              _c(
                "vs-col",
                {
                  staticClass: "p-1",
                  attrs: { type: "flex", "vs-justify": "center", "vs-w": "4" }
                },
                [
                  _c(
                    "vx-card",
                    {
                      attrs: {
                        title: "Datos Receptor",
                        "title-color": "primary"
                      }
                    },
                    [
                      _vm.encabezado.nominativa
                        ? _c(
                            "vs-row",
                            [
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "font-weight": "bolder" },
                                  attrs: { "vs-w": "3" }
                                },
                                [_vm._v("RUT")]
                              ),
                              _c(
                                "vs-col",
                                { staticClass: "p-1", attrs: { "vs-w": "9" } },
                                [_vm._v(_vm._s(_vm.encabezado.rutReceptor))]
                              ),
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "font-weight": "bolder" },
                                  attrs: { "vs-w": "3" }
                                },
                                [_vm._v("Razón Social")]
                              ),
                              _c(
                                "vs-col",
                                { staticClass: "p-1", attrs: { "vs-w": "9" } },
                                [_vm._v(_vm._s(_vm.encabezado.razonSocial))]
                              ),
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "font-weight": "bolder" },
                                  attrs: { "vs-w": "3" }
                                },
                                [_vm._v("Giro")]
                              ),
                              _c(
                                "vs-col",
                                { staticClass: "p-1", attrs: { "vs-w": "9" } },
                                [_vm._v(_vm._s(_vm.encabezado.giro))]
                              ),
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "font-weight": "bolder" },
                                  attrs: { "vs-w": "3" }
                                },
                                [_vm._v("Dirección")]
                              ),
                              _c(
                                "vs-col",
                                { staticClass: "p-1", attrs: { "vs-w": "9" } },
                                [_vm._v(_vm._s(_vm.encabezado.direccion))]
                              ),
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "font-weight": "bolder" },
                                  attrs: { "vs-w": "3" }
                                },
                                [_vm._v("Comuna")]
                              ),
                              _c(
                                "vs-col",
                                { staticClass: "p-1", attrs: { "vs-w": "9" } },
                                [_vm._v(_vm._s(_vm.encabezado.comuna))]
                              ),
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "font-weight": "bolder" },
                                  attrs: { "vs-w": "3" }
                                },
                                [_vm._v("Ciudad")]
                              ),
                              _c(
                                "vs-col",
                                { staticClass: "p-1", attrs: { "vs-w": "9" } },
                                [_vm._v(_vm._s(_vm.encabezado.ciudad))]
                              ),
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "font-weight": "bolder" },
                                  attrs: { "vs-w": "3" }
                                },
                                [_vm._v("Email")]
                              ),
                              _c(
                                "vs-col",
                                { staticClass: "p-1", attrs: { "vs-w": "9" } },
                                [_vm._v(_vm._s(_vm.encabezado.email))]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.encabezado.nominativa
                        ? _c(
                            "vs-row",
                            [
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "font-weight": "bolder" },
                                  attrs: { "vs-w": "3" }
                                },
                                [_vm._v("Email")]
                              ),
                              _c(
                                "vs-col",
                                { staticClass: "p-1", attrs: { "vs-w": "9" } },
                                [_vm._v(_vm._s(_vm.encabezado.email))]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "vs-col",
                {
                  staticClass: "p-1",
                  attrs: { type: "flex", "vs-justify": "center", "vs-w": "3" }
                },
                [
                  _c(
                    "vx-card",
                    {
                      attrs: {
                        title: _vm.tipoDocumento,
                        "title-color": "primary"
                      }
                    },
                    [
                      _vm.encabezado.tipoDocumento == 34 ||
                      _vm.encabezado.tipoDocumento == 39 ||
                      _vm.encabezado.tipoDocumento == 41
                        ? _c(
                            "vs-row",
                            [
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "font-weight": "bolder" },
                                  attrs: { "vs-w": "3" }
                                },
                                [_vm._v("Total")]
                              ),
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "text-align": "right" },
                                  attrs: { "vs-w": "9" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(
                                        new Intl.NumberFormat()
                                          .format(_vm.total)
                                          .replace(/,/g, ".")
                                      )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.encabezado.tipoDocumento == 33
                        ? _c(
                            "vs-row",
                            [
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "font-weight": "bolder" },
                                  attrs: { "vs-w": "4" }
                                },
                                [_vm._v("Total Neto")]
                              ),
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "text-align": "right" },
                                  attrs: { "vs-w": "8" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(
                                        new Intl.NumberFormat()
                                          .format(_vm.total)
                                          .replace(/,/g, ".")
                                      )
                                  )
                                ]
                              ),
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "font-weight": "bolder" },
                                  attrs: { "vs-w": "4" }
                                },
                                [_vm._v("IVA")]
                              ),
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "text-align": "right" },
                                  attrs: { "vs-w": "8" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(
                                        new Intl.NumberFormat()
                                          .format(_vm.iva)
                                          .replace(/,/g, ".")
                                      )
                                  )
                                ]
                              ),
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "font-weight": "bolder" },
                                  attrs: { "vs-w": "4" }
                                },
                                [_vm._v("Total")]
                              ),
                              _c(
                                "vs-col",
                                {
                                  staticClass: "p-1",
                                  staticStyle: { "text-align": "right" },
                                  attrs: { "vs-w": "8" }
                                },
                                [
                                  _vm._v(
                                    "$ " +
                                      _vm._s(
                                        new Intl.NumberFormat()
                                          .format(_vm.total + _vm.iva)
                                          .replace(/,/g, ".")
                                      )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "vs-col",
                {
                  staticClass: "p-1",
                  attrs: { type: "flex", "vs-justify": "center", "vs-w": "5" }
                },
                [
                  _vm.encabezado.tipoDocumento == 61
                    ? _c(
                        "vx-card",
                        {
                          attrs: {
                            title: "Referencias",
                            "title-color": "primary"
                          }
                        },
                        [
                          _vm.referencias.length == 0
                            ? _c(
                                "vs-row",
                                [
                                  _c("vs-col", { attrs: { "vs-w": "8" } }, [
                                    _vm._v("Sin referencias")
                                  ]),
                                  _c(
                                    "vs-col",
                                    {
                                      staticStyle: { "text-align": "right" },
                                      attrs: { "vs-w": "4" }
                                    },
                                    [
                                      _c(
                                        "vs-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            color: "primary",
                                            type: "filled"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.abrirReferencia()
                                            }
                                          }
                                        },
                                        [_vm._v("Agregar referencia")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.referencias.length > 0
                            ? _c(
                                "vs-row",
                                [
                                  _c("vs-col", { attrs: { "vs-w": "8" } }),
                                  _c(
                                    "vs-col",
                                    {
                                      staticStyle: { "text-align": "right" },
                                      attrs: { "vs-w": "4" }
                                    },
                                    [
                                      _c(
                                        "vs-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            color: "primary",
                                            type: "filled"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.abrirReferencia()
                                            }
                                          }
                                        },
                                        [_vm._v("Agregar referencia")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("div", {
                            staticStyle: { "margin-top": "10px", clear: "both" }
                          }),
                          _vm._l(_vm.referencias, function(ref, ind) {
                            return _c(
                              "div",
                              { key: ind, staticStyle: { width: "100%" } },
                              [
                                _c(
                                  "vs-button",
                                  {
                                    attrs: { color: "danger", type: "flat" },
                                    on: {
                                      click: function($event) {
                                        return _vm.eliminarReferencia(ind)
                                      }
                                    }
                                  },
                                  [
                                    _c("vs-icon", {
                                      attrs: { icon: "delete", color: "danger" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getTipoDocumento(ref.tipoDocumento)
                                    ) +
                                    " Nª " +
                                    _vm._s(ref.folio) +
                                    " del " +
                                    _vm._s(ref.formatFecha) +
                                    " "
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "vs-modal",
            {
              ref: "modalReferencias",
              attrs: { title: "Referenciar Documento" }
            },
            [
              _c(
                "vs-row",
                [
                  _c(
                    "vs-col",
                    { attrs: { "vs-w": "12" } },
                    [
                      _c("datepicker", {
                        attrs: { placeholder: "Fecha", required: "" },
                        model: {
                          value: _vm.referencia.fecha,
                          callback: function($$v) {
                            _vm.$set(_vm.referencia, "fecha", $$v)
                          },
                          expression: "referencia.fecha"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "vs-col",
                    { attrs: { "vs-w": "12" } },
                    [
                      _c(
                        "vs-select",
                        {
                          staticClass: "w-full select-large mt-2",
                          attrs: { required: "", label: "Tipo Documento" },
                          model: {
                            value: _vm.referencia.tipoDocumento,
                            callback: function($$v) {
                              _vm.$set(_vm.referencia, "tipoDocumento", $$v)
                            },
                            expression: "referencia.tipoDocumento"
                          }
                        },
                        _vm._l(_vm.tiposDocumento, function(item, index) {
                          return _c("vs-select-item", {
                            key: index,
                            attrs: { value: item.value, text: item.text }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "vs-col",
                    { attrs: { "vs-w": "12" } },
                    [
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-full mt-2",
                        attrs: {
                          label: "Motivo",
                          maxlength: "50",
                          required: ""
                        },
                        model: {
                          value: _vm.referencia.motivo,
                          callback: function($$v) {
                            _vm.$set(_vm.referencia, "motivo", $$v)
                          },
                          expression: "referencia.motivo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "vs-col",
                    { attrs: { "vs-w": "12" } },
                    [
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-full mt-2",
                        attrs: {
                          label: "Folio",
                          maxlength: "10",
                          required: ""
                        },
                        model: {
                          value: _vm.referencia.folio,
                          callback: function($$v) {
                            _vm.$set(_vm.referencia, "folio", $$v)
                          },
                          expression: "referencia.folio"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "vs-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { "vs-w": "12" }
                    },
                    [
                      _c(
                        "vs-button",
                        {
                          attrs: { size: "sm" },
                          on: {
                            click: function($event) {
                              return _vm.agregarReferencias()
                            }
                          }
                        },
                        [_vm._v("Agregar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }